export enum DeliveryOrderStatus {
  SIGNED = 'SIGNED',
}
